"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ed2curve = require("ed2curve");
var _sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var PublicKey_1 = require("./PublicKey");
var SecretKey_1 = require("./SecretKey");
var InputError_1 = require("../errors/InputError");
var KeyPair = (function () {
    function KeyPair() {
        this.public_key = new PublicKey_1.default();
        this.secret_key = new SecretKey_1.default();
    }
    KeyPair.new = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, ed25519_key_pair, kp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, _sodium.ready];
                    case 1:
                        _a.sent();
                        sodium = _sodium;
                        ed25519_key_pair = sodium.crypto_sign_keypair();
                        kp = ClassUtil_1.default.new_instance(KeyPair);
                        kp.secret_key = KeyPair.prototype._construct_private_key(ed25519_key_pair);
                        kp.public_key = KeyPair.prototype._construct_public_key(ed25519_key_pair);
                        return [2, kp];
                }
            });
        });
    };
    KeyPair.prototype._construct_private_key = function (ed25519_key_pair) {
        var sk_ed25519 = ed25519_key_pair.privateKey;
        var sk_curve25519 = ed2curve.convertSecretKey(sk_ed25519);
        if (sk_curve25519) {
            return SecretKey_1.default.new(sk_ed25519, sk_curve25519);
        }
        throw new InputError_1.default.ConversionError('Could not convert private key with ed2curve.', 409);
    };
    KeyPair.prototype._construct_public_key = function (ed25519_key_pair) {
        var pk_ed25519 = ed25519_key_pair.publicKey;
        var pk_curve25519 = ed2curve.convertPublicKey(pk_ed25519);
        if (pk_curve25519) {
            return PublicKey_1.default.new(pk_ed25519, pk_curve25519);
        }
        throw new InputError_1.default.ConversionError('Could not convert public key with ed2curve.', 408);
    };
    KeyPair.prototype.encode = function (encoder) {
        encoder.object(2);
        encoder.u8(0);
        this.secret_key.encode(encoder);
        encoder.u8(1);
        return this.public_key.encode(encoder);
    };
    KeyPair.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(KeyPair);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.secret_key = SecretKey_1.default.decode(decoder);
                    break;
                case 1:
                    self.public_key = PublicKey_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return KeyPair;
}());
exports.default = KeyPair;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/KeyPair.js
// module id = 17
// module chunks = 0 1